import { render, staticRenderFns } from "./DeleteContentAction.vue?vue&type=template&id=0745f49b"
import script from "./DeleteContentAction.vue?vue&type=script&lang=js"
export * from "./DeleteContentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports